/** Tiny Web Audio feedback — original, no external assets */

export class LabAudio {
  private ctx: AudioContext | null = null;
  private muted = false;
  private master = 0.22;

  setMuted(m: boolean) {
    this.muted = m;
  }

  isMuted() {
    return this.muted;
  }

  private ensure(): AudioContext | null {
    if (this.muted) return null;
    if (!this.ctx) {
      const AC = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
      if (!AC) return null;
      this.ctx = new AC();
    }
    if (this.ctx.state === 'suspended') void this.ctx.resume();
    return this.ctx;
  }

  private beep(freq: number, dur: number, type: OscillatorType = 'sine', gain = 1, delay = 0) {
    const ctx = this.ensure();
    if (!ctx) return;
    const t0 = ctx.currentTime + delay;
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, t0);
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(this.master * gain, t0 + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    osc.connect(g);
    g.connect(ctx.destination);
    osc.start(t0);
    osc.stop(t0 + dur + 0.02);
  }

  place() {
    this.beep(520, 0.08, 'triangle', 0.7);
  }

  run() {
    this.beep(300, 0.06, 'square', 0.5);
    this.beep(420, 0.08, 'square', 0.5, 0.05);
  }

  bounce() {
    this.beep(180 + Math.random() * 80, 0.05, 'sine', 0.35);
  }

  success() {
    this.beep(523, 0.1, 'sine', 0.7);
    this.beep(659, 0.1, 'sine', 0.7, 0.09);
    this.beep(784, 0.16, 'sine', 0.8, 0.18);
  }

  fail() {
    this.beep(200, 0.12, 'sawtooth', 0.35);
    this.beep(140, 0.18, 'sawtooth', 0.3, 0.1);
  }

  unlock() {
    this.beep(440, 0.08, 'triangle', 0.6);
    this.beep(660, 0.1, 'triangle', 0.6, 0.08);
    this.beep(880, 0.14, 'triangle', 0.7, 0.16);
  }

  click() {
    this.beep(640, 0.04, 'square', 0.25);
  }

  whoosh() {
    this.beep(120, 0.2, 'sawtooth', 0.15);
  }
}
